<template>
    <section class="colorlib-experience" data-section="experience">
        <div class="colorlib-narrow-content">
            <div class="row">
                <div class="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                    <span class="heading-meta">Experience</span>
                    <h2 class="colorlib-heading animate-box">Work Experience</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="timeline-centered">
                        <article class="timeline-entry animate-box" data-animate-effect="fadeInLeft">
                        <div class="timeline-entry-inner">
                            <div class="timeline-icon color-5">
                                <i class="icon-pen2"></i>
                            </div>
                            <div class="timeline-label">
                            <h2><a href="#">Front-End-Developer</a> <span>February 2022 - </span><span>to Present</span></h2>
                                <p>In the Qr-menu company I work with a team that team consists of 12 people, we build responsive websites, using the latest technologies, such as Vue.js and Bootstrap</p>
                            </div>
                        </div>
                        </article>

                        <article class="timeline-entry begin animate-box" data-animate-effect="fadeInBottom">
                        <div class="timeline-entry-inner">
                            <div class="timeline-icon color-none">
                            </div>
                        </div>
                        </article>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default{
        // eslint-disable-next-line vue/multi-word-component-names
        name: "Experience"
    }
</script>